import swcDir from "./dir";

export { swcDir };
